module.exports = __webpack_public_path__ + "img/archive_icon.b090bd56.svg";